import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function Contactos() {
  const [contactos, setContactos] = useState([])
  const [tags, setTags] = useState([])
  const [negocios, setNegocios] = useState([])
  const [sesiones, setSesiones] = useState([])
  const [buscar, setBuscar] = useState('')
  const [filterTag, setFilterTag] = useState('')
  const [filterNegocio, setFilterNegocio] = useState('')
  const [filterSesion, setFilterSesion] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState({ nombre: '', telefono: '', email: '', tags: [] })
  const [pagina, setPagina] = useState(1)

  const cargar = async () => {
    const params = { buscar, tag: filterTag, pagina }
    if (filterSesion) params.sesionId = filterSesion
    else if (filterNegocio) params.unidadNegocioId = filterNegocio
    const { data } = await api.get('/contactos', { params })
    setContactos(data.contactos)
  }
  useEffect(() => { cargar() }, [buscar, filterTag, filterNegocio, filterSesion, pagina])
  useEffect(() => {
    api.get('/contactos/tags/all').then(r => setTags(r.data))
    api.get('/negocios').then(r => setNegocios(r.data || [])).catch(() => {})
    api.get('/sesiones').then(r => {
      const arr = Array.isArray(r.data) ? r.data : (r.data.sesiones || [])
      setSesiones(arr)
    }).catch(() => {})
  }, [])

  const sesionesVisibles = filterNegocio
    ? sesiones.filter(s => s.unidadNegocioId === filterNegocio)
    : sesiones

  const cambiarNegocio = (v) => { setFilterNegocio(v); setFilterSesion(''); setPagina(1) }

  const [sincronizando, setSincronizando] = useState(false)
  const sincronizarNombres = async () => {
    setSincronizando(true)
    try {
      const { data } = await api.post('/contactos/backfill-nombres')
      toast.success(`Sincronizando nombres de ${data.encolados} contactos en segundo plano…`)
      setTimeout(cargar, 5000) // recargar después de 5s para ver resultados
    } catch {
      toast.error('Error al sincronizar')
    } finally {
      setSincronizando(false)
    }
  }

  const guardar = async (e) => {
    e.preventDefault()
    try {
      if (editando) {
        await api.put(`/contactos/${editando.id}`, form)
        toast.success('Actualizado')
      } else {
        await api.post('/contactos', form)
        toast.success('Creado')
      }
      setShowModal(false)
      setEditando(null)
      setForm({ nombre: '', telefono: '', email: '', tags: [] })
      cargar()
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error')
    }
  }

  const editar = (c) => {
    setEditando(c)
    setForm({ nombre: c.nombre || '', telefono: c.telefono || '', email: c.email || '', tags: c.tags || [] })
    setShowModal(true)
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar contacto?')) return
    await api.delete(`/contactos/${id}`)
    cargar()
    toast.success('Eliminado')
  }

  const toggleTag = (tagNombre) => {
    setForm(prev => ({
      ...prev,
      tags: prev.tags.includes(tagNombre)
        ? prev.tags.filter(t => t !== tagNombre)
        : [...prev.tags, tagNombre]
    }))
  }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <h1 className="text-2xl font-bold">👥 Contactos</h1>
        <div className="flex gap-2">
          <button className="btn btn-outline" onClick={sincronizarNombres} disabled={sincronizando} title="Actualiza el nombre de contactos que solo muestran números, consultando WhatsApp">
            {sincronizando ? '⏳ Sincronizando…' : '🔄 Sincronizar nombres'}
          </button>
          <button className="btn btn-primary" onClick={() => { setEditando(null); setForm({ nombre: '', telefono: '', email: '', tags: [] }); setShowModal(true) }}>+ Nuevo contacto</button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="flex gap-3 search-bar" style={{ flexWrap: 'wrap' }}>
          <input className="input" style={{ flex: '1 1 200px' }} placeholder="🔍 Buscar por nombre, teléfono o email..." value={buscar} onChange={e => setBuscar(e.target.value)} />
          <select className="select" value={filterTag} onChange={e => { setFilterTag(e.target.value); setPagina(1) }}>
            <option value="">Todas las etiquetas</option>
            {tags.map(t => <option key={t.id} value={t.nombre}>{t.nombre}</option>)}
          </select>
          <select className="select" value={filterNegocio} onChange={e => cambiarNegocio(e.target.value)}>
            <option value="">Todos los negocios</option>
            {negocios.map(n => <option key={n.id} value={n.id}>{n.nombre}</option>)}
          </select>
          <select className="select" value={filterSesion} onChange={e => { setFilterSesion(e.target.value); setPagina(1) }}>
            <option value="">Todos los números</option>
            {sesionesVisibles.map(s => <option key={s.id} value={s.id}>{s.nombre}{s.telefono ? ` · ${s.telefono}` : ''}</option>)}
          </select>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table table-card">
          <thead>
            <tr>
              <th>Nombre</th><th>Teléfono</th><th>Email</th><th>Etiquetas</th><th>Último contacto</th><th></th>
            </tr>
          </thead>
          <tbody>
            {contactos.map(c => (
              <tr key={c.id}>
                <td data-label="Nombre">
                  <div className="flex items-center gap-2">
                    <div className="avatar avatar-sm">{(c.nombre || '?')[0].toUpperCase()}</div>
                    {c.nombre}
                  </div>
                </td>
                <td data-label="Teléfono">{c.telefono}</td>
                <td data-label="Email">{c.email || '-'}</td>
                <td data-label="Etiquetas">{(c.tags || []).map(t => <span key={t} className="badge badge-primary" style={{ marginRight: 4 }}>{t}</span>)}</td>
                <td data-label="Último contacto">{c.ultimoContacto ? new Date(c.ultimoContacto).toLocaleDateString() : '-'}</td>
                <td>
                  <button className="btn btn-sm btn-ghost" onClick={() => editar(c)}>✏️</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => eliminar(c.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {contactos.length === 0 && <div className="empty-state">Sin contactos</div>}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editando ? 'Editar' : 'Nuevo'} contacto</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nombre</label><input className="input" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Teléfono (con código país, sin +)</label><input className="input" required value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="59171234567" /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                <div className="form-group">
                  <label className="form-label">Etiquetas</label>
                  <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
                    {tags.map(t => (
                      <button type="button" key={t.id} className={`badge ${form.tags.includes(t.nombre) ? 'badge-primary' : ''}`} style={{ cursor: 'pointer', border: '1px solid var(--border)' }} onClick={() => toggleTag(t.nombre)}>{t.nombre}</button>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
